import React from "react"

export interface IEnkInputFieldProps {
  label: string
  comments?: string
  children: React.ReactNode
  className?: string
}

export function EnkInputField(props: IEnkInputFieldProps) {
  const { label, className, children, comments } = props
  const firstChild = React.Children.toArray(children)[0] as React.ReactElement<{ id?: string }>
  const firstChildId = firstChild.props?.id
  return (
    <div className={className}>
      <label htmlFor={firstChildId} className="text-sm font-medium text-gray-900">
        {label}
      </label>
      {comments && <p className="mt-1 text-sm leading-6 text-gray-600">{comments}</p>}
      {children}
    </div>
  )
}
